import React, { useState } from 'react';
import './CaseStudySidebar.css';

function CaseStudySidebar({ caseStudyData, preguntaActualIndex, onSelectSection, selectedSectionType, selectedSectionId }) {
  const [expandedExisting, setExpandedExisting] = useState(true);
  const [expandedRequirements, setExpandedRequirements] = useState(true);

  if (!caseStudyData) {
    return null;
  }

  const numPreguntas = caseStudyData.num_preguntas || 3;
  const overview = caseStudyData.overview || '';
  const existingEnv = caseStudyData.existing_environment || { secciones: [] };
  const requirements = caseStudyData.requirements || { secciones: [] };

  const handleSectionClick = (sectionType, sectionId = null) => {
    onSelectSection(sectionType, sectionId);
  };

  const getSelectedSectionKey = () => {
    if (selectedSectionType === 'question') return 'question';
    if (selectedSectionType === 'overview') return 'overview';
    if (selectedSectionType === 'existing' && selectedSectionId) return `existing_${selectedSectionId}`;
    if (selectedSectionType === 'requirements' && selectedSectionId) return `requirements_${selectedSectionId}`;
    return 'overview';
  };

  const selectedSection = getSelectedSectionKey();

  return (
    <div className="case-study-sidebar">
      <div className="case-study-header">
        <div 
          className={`case-study-question-indicator ${selectedSection === 'question' ? 'active' : ''}`}
          onClick={() => handleSectionClick('question')}
        >
          Case Study Question: <strong>{preguntaActualIndex + 1}</strong> of {numPreguntas}
        </div>
      </div>

      <div className="case-study-sections">
        {/* Overview */}
        <div
          className={`case-study-section-item ${selectedSection === 'overview' ? 'active' : ''}`}
          onClick={() => handleSectionClick('overview')}
        >
          <span className="section-title">Overview</span>
        </div>

        {/* Existing Environment */}
        <div className="case-study-dropdown-section">
          <div
            className={`case-study-dropdown-header ${expandedExisting ? 'expanded' : ''}`}
            onClick={() => setExpandedExisting(!expandedExisting)}
          >
            <span className="section-title">Existing Environment</span>
            <span className="dropdown-arrow">{expandedExisting ? '▲' : '▼'}</span>
          </div>
          {expandedExisting && (
            <div className="case-study-dropdown-content">
              {existingEnv.secciones && existingEnv.secciones.map((seccion) => (
                <div
                  key={seccion.id}
                  className={`case-study-subsection-item ${selectedSection === `existing_${seccion.id}` ? 'active' : ''}`}
                  onClick={() => handleSectionClick('existing', seccion.id)}
                >
                  {seccion.titulo}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Requirements */}
        <div className="case-study-dropdown-section">
          <div
            className={`case-study-dropdown-header ${expandedRequirements ? 'expanded' : ''}`}
            onClick={() => setExpandedRequirements(!expandedRequirements)}
          >
            <span className="section-title">Requirements</span>
            <span className="dropdown-arrow">{expandedRequirements ? '▲' : '▼'}</span>
          </div>
          {expandedRequirements && (
            <div className="case-study-dropdown-content">
              {requirements.secciones && requirements.secciones.map((seccion) => (
                <div
                  key={seccion.id}
                  className={`case-study-subsection-item ${selectedSection === `requirements_${seccion.id}` ? 'active' : ''}`}
                  onClick={() => handleSectionClick('requirements', seccion.id)}
                >
                  {seccion.titulo}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CaseStudySidebar;
